import { routes } from "@v2/utils/router";
import { generatePath } from "react-router-dom";

/**
 * Where a project's agent lands when nothing more specific was asked for.
 *
 * Signup, the enable flow and the zero-project guard all ask this same
 * question, so they ask it here.
 */
export function getAgentProjectLandingPath({
  projectId,
}: {
  projectId: string;
}) {
  return generatePath(routes.agent.home, { projectId });
}
